import React from 'react';
import { CTAButton } from '../CTAButton';
import { ImageSlot } from '../ImageSlot';
export function HeroSection() {
  return <header className="bg-ink pb-16 md:pb-24 md:pt-12" data-id="element-90" data-mp="26aqvb7znjxr5">
      <div className="mx-auto w-full max-w-[720px]" data-id="element-91" data-mp="21a2w3z19salu">
        <ImageSlot name="INOLVIDABLE · El arte del placer con tus manos, con Beatriz Espina" aspect="aspect-square" src="https://cdn.magicpatterns.com/uploads/1ba3sbMvW7p6GsreTY2kob/Banner_para_la_pagina.png" eager data-id="element-92" data-mp="218rtw3nh3awu" />
        <div className="px-6 pt-14 text-center md:pt-16" data-id="element-93" data-mp="1nio97h48rp9i">
          <p className="text-[13px] font-medium uppercase tracking-[0.22em] text-gold" data-id="element-94" data-mp="1nh4s5oarha6o">
            CLASE EN VIVO · SOLO MAYORES DE 18
          </p>
          <h1 className="mt-6 font-serif text-[2.9rem] font-medium leading-[1.04] text-ivory md:text-[4.25rem]" data-id="element-95" data-mp="1dltcn3rj3yxv">
            Hay caricias que se olvidan. <em className="italic text-gold" data-id="element-96" data-mp="19l9k6dhwhji2">Las tuyas no.</em>
          </h1>
          <p className="mx-auto mt-7 max-w-[560px] text-[17px] leading-relaxed text-ivory/90 md:text-lg" data-id="element-97" data-mp="14klrzohxqwm9">
            En 2 horas en vivo, la DOC te enseña anatomía, ritmo y técnica, paso a paso y sin juicios.
          </p>
          <p className="mt-5 font-serif text-lg italic text-ivory/75" data-id="element-98" data-mp="36gp5s9bgwp0b">
            Con la MSc Beatriz Espina, sexóloga con 17 años educando sobre sexualidad.
          </p>
          <div className="mt-10" data-id="element-99" data-mp="2wpkp95658w3d">
            <CTAButton data-id="element-100" data-mp="3kem4bb9hf5hm" />
          </div>
          <p className="mt-6 border-y border-gold/30 py-3 text-[15px] leading-relaxed text-gold" data-id="element-101" data-mp="3kfoufgyzd3wh">
            Jueves 29 de octubre · 9 pm Argentina · Solo 100 lugares en vivo · $17 USD
          </p>
        </div>
      </div>
    </header>;
}